import { message, Button, Col, ConfigProvider, Form, Tag, Row, Tooltip, Space, Radio, Modal, Popconfirm, InputNumber, ProTableOt } from "./../../ui/ot";
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { default as ProTableOT } from "../../utility/ProTable_ot";
import NoReplyModal from "./NoReplyModal";
import { useNoReply } from "../controller/NoReplyController";
import PopconfirmForm from "../component/PopconfirmForm";
import ChatroomAdminModal from "../../../pages/app/views/ChatroomAdminModal";
import dayjs from 'dayjs';

const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const NoReplyMain = ({
    setActiveKey = () => { }

}) => {
    const columns = [
        {
            title: '訊息內容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '讀者名字',
            dataIndex: 'user_name',
            key: 'user_name',
        },
        {
            title: '回覆樣板',
            dataIndex: 'no_reply_autoreply_data',
            key: 'no_reply_autoreply_data',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {

                return (
                    <Space
                        direction='vertical'
                        wrap>
                        {
                            text.map((value) => {

                                return (
                                    <Tag color="green" >{value?.name}</Tag>
                                )
                            })
                        }
                    </Space>
                )
            }
        },
        {
            title: '歷史紀錄',
            key: 'option2',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (<Space wrap>
                    <Button
                        type='primary'
                        onClick={() => { handleOpenChatroom(record) }}>
                        查看紀錄
                    </Button>

                </Space>)
            }
        },
        {
            title: '訊息樣板',
            dataIndex: 'option1',
            key: 'option1',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (<Space wrap>
                    <Button
                        type='primary'
                        onClick={() => { handleEditRow(record) }}>
                        選擇樣板
                    </Button>
                    <Button
                        type='default'
                        onClick={() => { setActiveKey("ChatbotMessage") }}
                    >
                        新增樣板
                    </Button>
                </Space>)
            }
        },
        {
            title: '操作',
            valueType: 'option',
            key: 'option',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Space wrap>
                        <PopconfirmForm
                            title="發送訊息"
                            description="確定發送訊息?"
                            onConfirm={({ customize_title, customize_content }) => {
                                console.log(customize_title, customize_content)
                                postUserNoReply({ no_reply_id: record?.no_reply_id, customize_title, customize_content })
                            }}
                            onCancel={() => { }}
                            record={record}
                        >
                            發送
                        </PopconfirmForm>
                    </Space >
                )
            }
        },
        {
            title: '時間',
            dataIndex: 'no_reply_autoreply_data',
            key: 'time',
            sorter: false, // 關閉升降序功能
            render: (no_reply_autoreply_data) => {
                if (!no_reply_autoreply_data || no_reply_autoreply_data.length === 0) return null;
    
                return (
                    <Space direction="vertical">
                        {no_reply_autoreply_data.map((item, index) => (
                            <div key={index}>
                                {dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')}
                            </div>
                        ))}
                    </Space>
                );
            },
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [isAutoReply, setIsAutoReply] = useState(true)
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.no_reply_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.no_reply_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.no_reply_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.no_reply_id)
                selectRow = selectRow.filter(row => row.no_reply_id !== record.no_reply_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [chatroomAdminModalOpen, setChatroomAdminModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();
    const [chatroomform] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const [sendData, setSendData] = useState({})
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleOpenChatroom = (record) => {
        setAxiosMode("option")
        setChatroomAdminModalOpen(true)
        console.log({ user: record?.user_id })
        setSendData({
            user_id: record?.user_id,
            no_reply_id: record?.no_reply_id
        })
        // form.resetFields()

        // let no_reply_autoreply_data = record?.no_reply_autoreply_data
        // let no_reply_autoreply_data_first = no_reply_autoreply_data.find(ele => true)
        // let autoreply_id = no_reply_autoreply_data_first?.autoreply_id

        // let editData = {
        //     no_reply_id: record?.no_reply_id,
        //     autoreply_id,
        //     content: record?.content,
        // }
        // form.setFieldsValue({
        //     ...editData,
        // })
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        form.resetFields()

        let no_reply_autoreply_data = record?.no_reply_autoreply_data
        let no_reply_autoreply_data_first = no_reply_autoreply_data.find(ele => true)
        let autoreply_id = no_reply_autoreply_data_first?.autoreply_id

        let editData = {
            no_reply_id: record?.no_reply_id,
            autoreply_id,
            content: record?.content,
        }
        form.setFieldsValue({
            ...editData,
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                no_reply_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    no_reply_id: val?.no_reply_id
                }
            })
        }
        if (data.length > 0) {
            deleteNoReplyData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {

        }
        else if (axiosMode === "patch") {

            let data = [
                {
                    no_reply_id: values?.no_reply_id,
                    user_id: values?.user_id,
                    autoreply_id: values?.autoreply_id,
                    "no_reply_autoreply_data": [
                        null,
                        {
                            autoreply_id: values?.autoreply_id
                        }
                    ]


                }
            ]
            patchNoReplyData(data)
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "finish") {
            if (axiosMode === "getUserNoReply") {
                message.info("發送完成")
                actionRef.current.reload();
            }else if (axiosMode === "postUserNoReply") {
                message.info("發送完成")
                actionRef.current.reload();
            }
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }


    const {
        getUserNoReply,
        postUserNoReply,
        getNoReplyData,
        postNoReplyData,
        patchNoReplyData,
        deleteNoReplyData
    } = useNoReply({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
        actionRef.current.reloadAndRest();
    }, [isAutoReply])
    return <Row>
        <Col>
            <ChatroomAdminModal
                sendData={sendData}
                axiosMode={axiosMode}
                propsOpen={chatroomAdminModalOpen}
                propsSetOpen={setChatroomAdminModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

            // onFinish={onFormFinish}
            />
        </Col>
        <Col>
            <NoReplyModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
            />
        </Col>

        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={<Space>
                    <Radio.Group
                        options={[
                            {
                                label: '已回覆',
                                value: true,
                            },
                            {
                                label: '未回覆',
                                value: false,
                            },
                        ]}
                        onChange={(e) =>
                            setIsAutoReply(e.target.value)
                        }
                        value={isAutoReply}
                        optionType="button"
                        buttonStyle="solid"
                    />
                </Space>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'no_reply_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        is_auto_reply: isAutoReply,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return getNoReplyData(newParams)
                }}
                pageSize={pageSize}
                // rowSelection={{
                //     type: 'checkbox',
                //     selectedRowKeys: selectedRowKeys,
                //     ...rowSelection,
                // }}
                rowSelection={false}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}

            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default NoReplyMain


